<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <p v-if="preloader && requestServe" class="text-center">
        Este proceso puede llevar un tiempo. <br />
        <span class="font-weight-bold">Procesando: {{ loading }}% </span> 
      </p>
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Registro etapas')"
          :directory="$t('de evaluación')"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            :disabled="disabledsupport"
            @click="openDeleteModal"
          >
            Procesar
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="alert alert-info alert-dismissible fade show col-12 text-center" role="alert" v-if="disabledsupport">
      Usted consta como gestor de apoyo en este proceso.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row">
      <div class="col-sm-6" :class="{ 'loading-opacity': preloader }">
        <div class="mt-2" v-if="receipt_return_report">
          <strong>
            Registro de Ingreso de solicitud de acreditación y Acuse Recibo
          </strong>
          <br />
          <button
            type="submit"
            class="btn btn-success"
            @click.prevent="
              openTab(receipt_return_report, 'receipt_return_report')
            "
          >
            <app-icon name="file" />
            {{ $t("view") }}
          </button>
        </div>
      </div>

      <div
        class="col-sm-6"
        :class="{ 'loading-opacity': preloader }"
        style="text-align: right"
      >
        <div class="mt-2" style="text-align: center" v-if="request_signed">
          <strong>Solicitud de acreditación firmada</strong>
          <br />
          <a
            class="btn btn-success"
            :href="`${request_signed}`"
            target="_blank"
          >
            <app-icon name="file" /> Ver</a
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-6">
        <strong> AREA </strong>
        <p>{{ application_name }}</p>
      </div>
      <div class="col-sm-6">
        <strong>Norma a evaluar</strong>
        <p>{{ rule_name }}</p>
      </div>
    </div>
    <hr />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-6">
        <strong> Expediente </strong>
        <br />
        <a
          :href="`/accreditations/applications/${accreditationApplicationId}`"
          target="_blank"
          v-if="showlink"
          >{{ record }}</a
        >
        <p v-if="!showlink">{{ record }}</p>
      </div>
      <div class="col-sm-6">
        <!-- <strong> Evaluación In Situ </strong> -->
      </div>
    </div>
    <hr />
    <div class="row" :class="{ 'loading-opacity': preloader }" ><!--v-if="showInput"-->
      <div class="col-sm-6">
        <strong>¿Ingresar manualmente código de evaluación? </strong>
        <!-- <strong> Ingrese el código de evaluación </strong> -->
        <br />
        
        <app-input
          type="radio-buttons"
          class="mb-2"
          v-model="code_eval"
          :list="isActive"
        />
        <!--<div v-if="code_eval">-->
        <div v-if="code_eval">
          <div class="form-group ml-1 row">
            <app-input
              type="text"
              v-model="code_name"
              placeholder="Ingrese código de evaluación"
              :required="true"
            />
            <button
              type="button"
              class="btn btn-primary ml-3"
              v-if="registers.length > 0"
              :class="{ 'loading-opacity': preloader }"
              :disabled="disabledsupport"
              @click="updateCodeEvalTest"
            >
              Actualizar
            </button>

          </div>

          <br>
          <button
            type="button"
            class="btn btn-info btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            Consultar códigos de evaluación usados.
          </button>
        </div>
      </div>
    </div>
    <code-eval-modal
      v-if="isAddEditModalActive"
      @close-modal="closeAddEditModal"
      modalTitle="Código de evaluaciones"
      editModalTitle="Seleccione el código de la evaluación."
      :selected-url="selectedUrl"
      :codeSelected="codeSelected"
      :accApp="accApp"
    />

    <hr />
    <div class="row">
      <div class="col-sm-12" style="text-align: center" v-if="!disabledsupport">
        <button
          type="button"
          class="btn btn-primary mr-2"
          @click="addInputTestistifications"
          :class="{ 'loading-opacity': preloader }"
          :disabled="registers.length > 0"
        >
          Registrar etapa
        </button>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <h5 class="text-primary">Etapas Registrada</h5>
      </div>
    </div>
    <hr />
    <div
      class="row"
      v-for="(item, key) in registers"
      :key="key"
      :class="{ 'loading-opacity': preloader }"
    >
      <div class="col-sm-8">
        <p>
          <strong>Evaluación InSitu / Remota {{ item.code }}</strong>
        </p>
      </div>
      <div class="col-sm-4">
        <div class="row">
          <div class="col-sm-3">
            <button
              v-if="item.state == 1"
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              :disabled="disabledsupport"
              @click="addCriticalLocation(item.id, item.code)"
            >
              <app-icon name="plus" />
              LC
            </button>
          </div>
          <div class="col-sm-3">
            <button
              v-if="item.state == 1"
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              :disabled="disabledsupport"
              @click="addTestification(item.id, item.code)"
            >
              <app-icon name="plus" />
              T
            </button>
          </div>
          <div class="col-sm-2" v-if="item.state == 0">
            <button
              type="submit"
              class="btn btn-danger btn-sm mr-2"
              :disabled="disabledsupport"
              @click="updateEvaluationState(item.id)"
            >
              <app-icon name="power" />
            </button>
          </div>
          <div class="col-sm-2" v-if="item.state == 1">
            <button
              type="submit"
              class="btn btn-success btn-sm mr-2"
              :disabled="disabledsupport"
              @click="updateEvaluationState(item.id)"
            >
              <app-icon name="power" />
            </button>
          </div>
        </div>
      </div>
      <br />
      <br />
      <hr />

      <div class="col-sm-10 mx-auto" :class="{ 'loading-opacity': preloader }">
        <div
          class="row d-flex"
          v-for="(items, key) in item.testifications"
          :key="key"
        >
          <div class="col-sm-6 my-2" v-if="items.state == 1">
            <p
              class="text-center d-flex align-items-center justify-content-end mx-5 mt-2"
            >
              <!-- <strong>Testificación {{ items.code }}</strong> -->
              <strong>{{ items.code }}</strong>
            </p>
          </div>
          <div class="col-sm-6  my-2" v-if="items.state == 0">
            <p
              class="text-center d-flex align-items-center justify-content-end mx-5 mt-2"
            >
              <strong class="text-danger">Estado inactivo</strong>
            </p>
          </div>
          <div class="col-sm-6 my-2">
            <div class="row" v-if="item.state == 1">
              <div class="col-sm-2" v-if="items.state == 1">
                <button
                  type="button"
                  class="btn btn-success btn-sm mr-2"
                  :disabled="disabledsupport"
                  @click="stateTestification(items.id)"
                >
                  <app-icon name="power" />
                </button>
              </div>

              <div
                class="col"
                v-if="items.state == 1 "
              >
                <div class="input-group input-group-sm">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Código"
                    aria-label="Código"
                    aria-describedby="button-addon2"
                    v-model="items.codeRef"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary btn-sm"
                      type="button"
                      id="button-addon2"
                      :disabled="disabledsupport"
                      @click="updateCode(items, item.code)"
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-2" v-if="items.state == 0">
                <button
                  type="button"
                  class="btn btn-danger btn-sm mr-2"
                  :disabled="disabledsupport"
                  @click="stateTestification(items.id)"
                >
                  <app-icon name="power" />
                </button>
              </div>
            </div>
            <div class="row" v-if="item.state == 0">
              <div class="col-sm-2" v-if="items.state == 1">
                <button
                  type="button"
                  class="btn btn-success btn-sm mr-2"
                  :disabled="true"
                >
                  <app-icon name="power" />
                </button>
              </div>
              <div class="col-sm-2" v-if="items.state == 0" :disabled="true">
                <button type="button" class="btn btn-danger btn-sm mr-2">
                  <app-icon name="power" />
                </button>
              </div>
            </div>
          </div>
          <br /><br />
        </div>
        <br />
      </div>
      <br />
    </div>
    <hr />
    <!-- <form ref="form" :class="{ 'loading-opacity': preloader }" data-url="/accreditationtechnical/quotations/update">
      <div class="row" style="width: 100%">
        <div class="col-sm-12" style="text-align: center">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            Procesar
          </button>
        </div>
      </div>
    </form> -->
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
export default {
  name: "RegisterStages",
  mixins: [FormMixin],
  components: {},

  props: {
    accreditationApplicationId: String,
    codeSelected: String,
    //accApp: String,
  },
  data() {
    return {
      record: "",
      showlink: false,
      preloader: false,
      TestificationList: [],
      evaluations: [],
      inputs: [],
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      number_testifications: 1,
      deleteConfirmationModalActive: false,
      deleteConfirmationModalActive: false,
      number_concat: 0,
      accreditation: [],
      loading: 0,
      requestServe: false,
      rule_name: "",
      application_name: "",
      accAppData: null,
      registers: [],
      dataEvaluation: [],
      attached_file: {},
      receipt_return_report: "",
      accApp: null,
      request_signed: "",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      showInput: false,
      code_eval: 0,
      code_name: "",
      accType: null,
      disabledsupport: false,
    };
  },
  created() {
    this.accApp = this.accreditationApplicationId ;
    this.TestificationList = this.$store.state.accreditation.testification;
    this.accreditationData();
    this.evaluationTestification();
  },
  watch: {
    "$store.state.accreditation.testification": function() {
      this.TestificationList = this.$store.state.accreditation.testification;
    },
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#code-eval-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.deleteLoader = false;
      this.reSetData();
    },
    returnPage() {
      window.location.href = "/accreditationtechnical/quotations";
    },
    openTab(obj) {
      const w = window.open(obj.full_url, "_blank");
      w.focus();
    },
    updateCode(value, original) {
      this.preloader = true;
      const code = `${original}-${value.codeRef}`;
      const url = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/updateCodeEval/${value.id}`;
      axios
        .patch(url, { code })
        .then(() => {
          this.preloader = false;
          this.$toastr.s(this.$t("Código actualizado"));
          value.code = code;
        })
        .catch(() => {
          this.preloader = false;
          this.$toastr.e(this.$t("No se pudo actualizar el código"));
        });
    },
    confirmed() {
      this.deleteLoader = true;
      this.preloader = true;
      this.requestServe = true;
      const url = `${actions.ACCREDITATIONS_QUOTATIONS}/update`;
      const requestServe = {};
      requestServe["accreditation_application_id"] = this.accreditationApplicationId;

      let options = {
        method: 'POST',
        url: url,
        data: requestServe
      }

      if(this.accAppData.is_save_lots){
        options.url = options.url + `?page=${this.accAppData.next_lot}`;
      }
      let attempts = 0;
      async function request(options,toastr,loading,num = 0){
        let info = null;
        try{
            const response = await axios.request(options);
            info = await response.data;

            if(info.message === 'B'){
              return;
            }

            if(info.finally){
              throw Error(info.message);
            }

            if(info.page === info.lastPage){
              return;
            }

            if(!info.repeat){
                if(num > 1){
                  options.url = options.url.replace(/\?page=[0-9]+/,`?page=${info.page + 1}`);
                }else {
                  options.url = url + `?page=${ info.page + 1}`;
                }
                return request(options,toastr,loading,info.page);
            }else{
                attempts++;
                if(attempts === 5){
                  throw Error('Error desconocido, por favor intentelo mas tarde.');
                  return;
                }
                return request(options,toastr,loading);
            }
        }catch(e){
          throw Error(e.message);
          return;
        }finally{
          loading(info.porcent);
        }
      }

      request(options,this.$toastr,setLoading,this.accAppData.is_save_lots ? this.accAppData.next_lot : 0)
      .then(() => {
        this.$toastr.s(this.$t("complaint_success"));
        this.returnPage();
      })
      .catch(e => {
        this.$toastr.e(e.message);
      })
      .finally(() => {
        this.preloader = false;
        this.requestServe = false;
        $("#modal-confirm-id").modal("hide");
      });

      const self = this;
      function setLoading(porcent){
        self.loading = porcent;
      }

      // axios
      //   .post(url, request)
      //   .then(({ data: res }) => {
      //     this.deleteLoader = false;
      //     $("#modal-confirm-id").modal("hide");
      //     this.cancelled();
      //     if (res.status === true) {
      //       this.$toastr.s("Registro procesado con exito");
      //       //this.returnPage();
      //     } else {
      //       this.preloader = false;
      //       this.$toastr.e(res.data);
      //     }
      //   })
      //   .catch(({ error }) => {
      //     this.preloader = false;
      //   });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    addInputTestistifications() {
      var accreditationData = {};
      accreditationData[
        "accreditationApplicationId"
      ] = this.accreditationApplicationId;
      accreditationData[
        "accreditation_area_id"
      ] = this.accreditation.accreditation_area_id;
      accreditationData["code_eval"] = this.code_eval;
      accreditationData["code_name"] = this.code_name;
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/storeEvaluation`;
      axios.post(selectedUrl, accreditationData).then(({ data: res }) => {
        if (res.data === "OK") {
          this.$toastr.s(this.$t("updated_success"));
          this.evaluationTestification();
        } else {
          this.$toastr.e(res.data);
        }
      });
    },

    stateTestification(id) {
      this.preloader = true;
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/updateTestificationState/${id}`;
      axios.get(selectedUrl).then((response) => {
        this.evaluationTestification();
        this.preloader = false;
        this.$toastr.s(this.$t("updated_success"));
      });
    },
    evaluationTestificationCharge() {
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/evaluationTestification/${this.accreditationApplicationId}`;
      axios.get(selectedUrl).then((response) => {
        this.registers = response.data;
      });
    },

    evaluationTestification() {
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/evaluationTestification/${this.accreditationApplicationId}`;
      axios.get(selectedUrl).then((response) => {
        this.registers = response.data;
        if (this.registers.length > 0) {
          this.code_eval = 1;
          this.code_name = this.registers[0].code;
          this.accType = this.registers[0].activity.name;
          if (this.accType == "INSPECCION") {
            this.registers[0].testifications = this.registers[0].testifications.map(
              (item) => {
                const [code] = item.code.split("-").reverse();
                return { ...item, codeRef: code };
              }
            );
          }
        }
      });
    },
    addTestification(id, code) {
      this.preloader = true;
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/verifyTestification/${id}`;
      axios.get(selectedUrl).then((response) => {
        var testificationNumber = response.data.length;
        var column = {};
        column["cod_testification_in_situ"] =
          code + "-T".concat(testificationNumber + 1);
        column["id_pcr_evaluation_in_situ"] = id;
        column["accreditation_id"] = this.accreditationApplicationId;
        this.preloader = false;
        var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/storeTestification`;
        axios.post(selectedUrl, column).then((response) => {
          this.evaluationTestificationCharge();
          this.preloader = false;
          this.$toastr.s(this.$t("created_success"));
        });
      });
    },

    addCriticalLocation(id, code) {
      this.preloader = true;
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/verifyCriticalLocation/${id}`;
      axios.get(selectedUrl).then((response) => {
        var criticalNumber = response.data.length;
        var column = {};
        column["cod_critical_location"] =
          code + "-LC".concat(criticalNumber + 1);
        column["id_pcr_evaluation_in_situ"] = id;
        column["accreditation_id"] = this.accreditationApplicationId;
        this.preloader = false;
        var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/storeCriticalLocation`;
        axios.post(selectedUrl, column).then((response) => {
          this.evaluationTestificationCharge();
          this.preloader = false;
          this.$toastr.s(this.$t("created_success"));
        });
      });
    },
    accreditationData() {
      this.preloader = true;
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/form/${this.accreditationApplicationId}`;
      axios.get(selectedUrl).then((response) => {
        this.accAppData = response.data;
        if (response.data) {
          //id session
          this.axiosGet(
              `/accreditations/session/getauth`
            )
              .then((rsession) => {
                if (rsession.status == 200) {
                  if (response.data.support_technique == rsession.data && response.data.responsible_technician != response.data.support_technique) {
                    this.disabledsupport = true;
                  } else {
                    this.disabledsupport = false;
                  }
                  localStorage.setItem("auth_id", this.disabledsupport);
                }
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {});
        } 

        if (
          response.data.accreditation_area.name == "CERTIFICACIÓN" &&
          response.data.accreditation_type.name.includes("Vigilancia")
        ) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
        this.rule_name = response.data.accreditation_activity.rule_name;
        this.application_name =
          response.data.accreditation_area.name;
        this.accreditation = response.data;
        this.record = response.data.record;
        this.receipt_return_report = response.data.receipt_return_report;
        this.preloader = false;
        if (response.data.request_signed) {
          this.request_signed = response.data.request_signed.full_url;
        }
        var accType = response.data.accreditation_type.name;
        if (accType.match(/Acreditación Inicial*/)) {
          this.showlink = true;
        }
      });
    },

    updateEvaluationState(id) {
      this.preloader = true;
      var selectedUrl = `${actions.ACCREDITATIONS_QUOTATIONS}/updateEvaluationState/${id}`;
      axios.get(selectedUrl).then((response) => {
        this.evaluationTestificationCharge();
        this.preloader = false;
        this.$toastr.s(this.$t("updated_success"));
      });
    },

    submit() {
      if (!this.inputs.file) {
        this.$toastr.e(this.$t("Es necesario subir un archivo"));
      } else {
        let formData = new FormData();

        formData.append("file", this.inputs.file);
        formData.append(
          "accreditation_application_id",
          this.accreditationApplicationId
        );
        formData.append(
          "accreditation_application_id",
          this.accreditationApplicationId
        );
        if (this.delete_file) {
          formData.append("delete_file", true);
        }
        this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("created_success"));
      window.location = `${actions.ACCREDITATIONS_QUOTATIONS}`;
    },
    updateCodeEvalTest() {
      var updateEvalTest = {};
      updateEvalTest["id"] = this.registers[0].id;
      updateEvalTest["code_name"] = this.code_name;
      this.code_name = this.code_name.trim();
      if (!this.code_name){
        this.$toastr.e("El campo esta vacio");
      } else {
        var urlCode = `${actions.ACCREDITATIONS_QUOTATIONS}/updateCodeEval`;
        axios.post(urlCode, updateEvalTest).then(({ data: res }) => {
        this.code_name = this.code_name.trim();
        if (res.data === "noCode") {
          this.$toastr.e("El código ingresado ya existe");
        } else {
          this.$toastr.s(this.$t("updated_success"));
          this.evaluationTestification();
        }
        
      });

      }
      
    }
  },
};
</script>
